const LINK_PANEL_MODAL = "linkPanelContainer";
const LINK_PANEL_MODAL_OPTION_LINK = "link-radio";
const LINK_PANEL_MODAL_OPTION_ANCHOR = "anchor-radio";
const LINK_PANEL_MODAL_LINK_INPUT = "linkPanelInput";
const LINK_SETTINGS_CHECKBOX_NEW_TAB = "linkPanelBlankCheckbox";
const LINK_SETTINGS_CHECKBOX_NOREFERRER = "linkPanelNoreferrerCheckbox";
const LINK_SETTINGS_CHECKBOX_NOFOLLOW = "linkPanelRelCheckbox";
const LINK_SETTINGS_CHECKBOX_SPONSORED = "linkPanelSponsoredCheckbox";
const LINK_PANEL_MODAL_ANCHOR_CONTENT = "linkPanelAnchorContent";
const LINK_PANEL_MODAL_SAVE_BUTTON = "actionButtonSave";
const LINK_PANEL_MODAL_REMOVE_BUTTON = "linkPanelContainerRemove";

export { LINK_PANEL_MODAL, LINK_PANEL_MODAL_ANCHOR_CONTENT, LINK_PANEL_MODAL_LINK_INPUT, LINK_PANEL_MODAL_OPTION_ANCHOR, LINK_PANEL_MODAL_OPTION_LINK, LINK_PANEL_MODAL_REMOVE_BUTTON, LINK_PANEL_MODAL_SAVE_BUTTON, LINK_SETTINGS_CHECKBOX_NEW_TAB, LINK_SETTINGS_CHECKBOX_NOFOLLOW, LINK_SETTINGS_CHECKBOX_NOREFERRER, LINK_SETTINGS_CHECKBOX_SPONSORED };
//# sourceMappingURL=data-hooks.js.map
